import React from 'react';
import TableBody from 'components/data-visualization/Table/Body';
import DSPTableRow from './DSPTableRow';
import { IChartItem } from './types';

interface ILocalChartRows {
  charts: IChartItem[];
  isSmallScreen: boolean;
  productType: string;
  showProductColumn: boolean;
}

const LocalChartRows: React.FC<ILocalChartRows> = (props) => {
  const { charts, isSmallScreen, productType, showProductColumn } = props;

  if (charts && !charts.length) {
    return null;
  }
  return (
    <TableBody>
      {charts.map(
        (chart: IChartItem, index: number): JSX.Element => {
          const key = `LCR-${chart.chartId}-${index}`;
          return (
            <DSPTableRow
              key={key}
              chart={chart}
              isSmallScreen={isSmallScreen}
              productType={productType}
              showProductColumn={showProductColumn}
            />
          );
        }
      )}
    </TableBody>
  );
};

export default LocalChartRows;
